import { CONSTANTS } from ".";
import { filterCVPoints, groupCVHeaders } from "../actions";
import templateData from "./template.json";

export const TEMPLATE_SETTINGS = {
  "horizontal": {
    "initial": 20,
    "propNames": ["paddingLeft", "paddingRight"]
  },
  "vertical": {
    "initial": 20,
    "propNames": ["paddingTop", "paddingBottom"]
  },
  "typeface": {
    "default": "Times New Roman",
    "propNames": ["fontFamily"],
    "options": ["Times New Roman", "Segoe UI", "Arial", "Arial Black", "Comic Sans MS", "Impact", "Tahoma", "Trebuchet MS", "Verdana", "Courier New", "Lucida Console"]
  },
  "lineHeight": {
    "default": 1,
    "propNames": ["lineHeight"],
    "options": [1, 1.1, 1.15, 1.2, 1.25, 1.3, 1.35, 1.4, 1.45, 1.5, 1.75, 2, 2.25, 2.5, 2.75, 3]
  },
  "listStyle": {
    "default": "disc",
    "propNames": ["listStyleType"]
  }
}

export const TEMPLATE_CONFIGPATHS = {
  "collegeLogo": "personal_details.section_layout.components.rows.0.config"
}

export const TEMPLATE_CONFIG = templateData;

export const academicDetail = (detail, i) => {
  let instituteName = "";
  let acadType = []
  if (detail.academic_type === "X" || detail.academic_type === "XII") {
    instituteName = `academic_detail.${i}.school_name`
    acadType = [
      CONSTANTS.ACADEMIC_TYPES[detail.academic_type],
      " | ",
      `academic_detail.${i}.board_short_form`
    ]
  } else {
    instituteName = [`academic_detail.${i}.college_name`, ", ", `academic_detail.${i}.university_name`]
    acadType = [`academic_detail.${i}.degree_name`]
  }
  return (
    {
      "key": i,
      "id": i,
      "target": "academic_detail",
      "class": "borderLeft borderBottom",
      "columns": [
        {
          "grid_size": 3,
          "class": "borderRight px-0",
          "itemsClass": "px-1",
          "items": [
            {
              "data": acadType
            }
          ]
        },
        {
          "grid_size": 2,
          "class": "borderRight px-0",
          "itemsClass": "px-1",
          "items": [
            {
              "type": "DATE",
              "format": "YYYY",
              "data": `academic_detail.${i}.year_end`
            }
          ]
        },
        {
          "grid_size": 5,
          "class": "borderRight px-0",
          "itemsClass": "px-1",
          "items": [
            {
              "data": instituteName
            }
          ]
        },
        {
          "grid_size": 2,
          "class": "borderRight px-0",
          "itemsClass": "px-1",
          "items": [
            {
              "type": "SCORE",
              "data": [`academic_detail.${i}.score_value`, " ", `academic_detail.${i}.score_type`]
            }
          ]
        }
      ]
    }
  )
}

export const proDetail = (detail, i, cvPoints) => {
  let section = detail.project_id ? "project" : "professional_detail";
  let cvDetail = [],
    cvPointKeys = [],
    id = detail.project_id || detail.professional_id;
  if (cvPoints && cvPoints[id]) {
    cvDetail = cvPointDetails(cvPoints[id]);
    Object.keys(cvPoints[id]).forEach(header => {
      cvPointKeys.push(...cvPoints[id][header].map(cv => cv.cv_point_id))
    })
  }
  return ({
    "config": {},
    "key": id,
    "target": section,
    "cv_keys": cvPointKeys,
    "columns": [{
      "grid_size": 12,
      "config": {},
      "items": [],
      "rows": [{
        "config": {
          "background": "#D9D9D9"
        },
        "id": id,
        "target": section,
        "columns": [
          {
            "grid_size": 4,
            "config": {
              "border": "1px solid",
              "border-width": "0 0 1px 1px",
              // "background": "#D9D9D9",
              "font-weight": "bold",
              "text-align": "left"
            },
            "items": [
              {
                "data": `${section}.${i}.company_name`
              }
            ]
          },
          {
            "grid_size": 4,
            "config": {
              "border": "1px solid",
              "border-width": "0 0 1px 0",
              // "background": "#D9D9D9",
              "font-weight": "bold",
              "text-align": "center"
            },
            "items": [
              {
                "data": `${section}.${i}.${detail.project_id ? "project_title" : "designation_name"}`
              }
            ]
          },
          {
            "grid_size": 4,
            "config": {
              "border": "1px solid",
              "border-width": "0 1px 1px 0",
              // "background": "#D9D9D9",
              "text-align": "right"
            },
            "items": [
              {
                "type": "DATE",
                "format": "MMM'YY",
                "data": [
                  `${section}.${i}.start_date`,
                  " - ",
                  `${section}.${i}.end_date`
                ]
              }
            ]
          }
        ]
      }, ...cvDetail]
    }]

  })
}
export const projDetail = (detail, i, cvPoints) => {
  let section = "project";
  let cvDetail = [],
    cvPointKeys = [],
    id = detail.project_id
  if (cvPoints && cvPoints[id]) {
    Object.keys(cvPoints[id]).forEach(header => {
      cvPointKeys.push(...cvPoints[id][header].map(cv => {
        cvDetail.push({
          "key": cv.cv_point_id,
          "id": cv.cv_point_id,
          "target": "cv_point",
          "config": {},
          "columns": [
            {
              "config": {},
              "items": [
                {
                  "type": "LISTITEM",
                  "data": `cv_point.${cv.cv_point_id}.text`
                }
              ]
            }
          ]
        })
        return cv.cv_point_id
      }))
    })
  }
  return ({
    "config": {},
    "key": id,
    "target": section,
    "cv_keys": cvPointKeys,
    "columns": [{
      "grid_size": 12,
      "config": {
        "border-bottom": "1px solid #fff"
      },
      "items": [],
      "rows": [{
        "config": {
        },
        "id": id,
        "target": section,
        "columns": [
          {
            "grid_size": 2,
            "config": {
              "background": "#D9D9D9",
              "text-align": "center",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "font-weight": "bold"
            },
            "items": [
              {
                "data": `${section}.${i}.company_name`
              }
            ]
          },
          {
            "grid_size": 8,
            "rows": [{
              "columns": [{
                "items": [
                  {
                    "data": `${section}.${i}.company_name`
                  }
                ],
                "config": {
                  "font-weight": "bold",
                  "text-align": "left"
                }
              }]
            }, ...cvDetail],
            "items": []
          },
          {
            "grid_size": 2,
            "config": {
              "background": "#D9D9D9",
              "text-align": "center",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center"
            },
            "items": [
              {
                "type": "DATE",
                "format": "MMM'YY",
                "data": [
                  `${section}.${i}.start_date`,
                  " - ",
                  `${section}.${i}.end_date`
                ]
              }
            ]
          }
        ]
      }]
    }]

  })
}

export const personalDetail = (age, language) => {
  return {
    "type": "TEXT",
    "data": [
      "user_info.gender",
      ", ",
      `${age} `,
      "Years | ",
      `${language}`
    ]
  }
}

export const cvPointDetails = (cvPoints) => {
  return Object.keys(cvPoints).map(header => {
    return {
      "config": {},
      "columns": [
        {
          "config": {
            "border": "1px solid",
            "border-width": "0 1px 1px 1px"
          },
          "items": [],
          "rows": [
            {
              "columns": [
                {
                  "grid_size": 2,
                  "class": "cvHeader",
                  "config": {},
                  "items": [
                    {
                      "data": header
                    }
                  ]
                },
                {
                  "grid_size": 10,
                  "config": {},
                  "items": [],
                  "class": "cvList",
                  "rows": cvPoints[header].map(cv => {
                    return {
                      "key": cv.cv_point_id,
                      "id": cv.cv_point_id,
                      "target": "cv_point",
                      "config": {},
                      "columns": [
                        {
                          "config": {},
                          "items": [
                            {
                              "type": "LISTITEM",
                              "data": `cv_point.${cv.cv_point_id}.text`
                            }
                          ]
                        }
                      ]
                    }
                  })
                }
              ]
            }
          ]
        }
      ]
    }
  })

}
export const porDetail = (detail, i, cvPoints) => {
  let section = "position_of_responsibility";
  let cvDetail = [],
    cvPointKeys = [],
    id = detail.id
  if (cvPoints && cvPoints[id]) {
    Object.keys(cvPoints[id]).forEach(header => {
      cvPointKeys.push(...cvPoints[id][header].map(cv => {
        cvDetail.push({
          "key": cv.cv_point_id,
          "id": cv.cv_point_id,
          "target": "cv_point",
          "config": {},
          "columns": [
            {
              "config": {},
              "items": [
                {
                  "type": "LISTITEM",
                  "data": `cv_point.${cv.cv_point_id}.text`
                }
              ]
            }
          ]
        })
        return cv.cv_point_id
      }))
    })
  }
  return ({
    "config": {},
    "key": id,
    "target": section,
    "cv_keys": cvPointKeys,
    "columns": [{
      "grid_size": 12,
      "config": {
        "border-bottom": "1px solid #fff"
      },
      "items": [],
      "rows": [{
        "config": {
        },
        "id": id,
        "target": section,
        "columns": [
          {
            "grid_size": 2,
            "config": {
              "background": "#D9D9D9",
              "text-align": "center",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "font-weight": "bold"
            },
            "items": [
              {
                "data": `${section}.${i}.designation_name`
              }
            ]
          },
          {
            "grid_size": 8,
            "rows": [{
              "columns": [{
                "items": [
                  {
                    "data": `${section}.${i}.college_name`
                  }
                ],
                "config": {
                  "font-weight": "bold",
                  "text-align": "left"
                }
              }]
            }, ...cvDetail],
            "items": []
          },
          {
            "class": "cvBlocks",
            "grid_size": 2,
            "config": {
            },
            "items": [
              {
                "type": "DATE",
                "format": "MMM'YY",
                "data": [
                  `${section}.${i}.start_date`,
                  " - ",
                  `${section}.${i}.end_date`
                ]
              }
            ]
          }
        ]
      }]
    }]

  })
}
export const ecDetail = (detail, i, cvPoints) => {
  let section = "extra_curricular_activity";
  let cvDetail = [],
    cvPointKeys = [],
    id = detail.extra_curricular_id
  if (cvPoints && cvPoints[id]) {
    Object.keys(cvPoints[id]).forEach(header => {
      cvPointKeys.push(...cvPoints[id][header].map(cv => {
        cvDetail.push({
          "key": cv.cv_point_id,
          "id": cv.cv_point_id,
          "target": "cv_point",
          "config": {},
          "columns": [
            {
              "grid_size": 11,
              "config": {},
              "items": [
                {
                  "type": "LISTITEM",
                  "data": `cv_point.${cv.cv_point_id}.text`
                }
              ]
            },
            {
              "grid_size": 1,
              "config": {},
              "items": [
                {
                  "type": "DATE",
                  "format": "YYYY",
                  "data": `${section}.${i}.activity_date`
                }
              ]
            }
          ]
        })
        return cv.cv_point_id
      }))
    })
  }
  return ({
    "config": {},
    "key": id,
    "target": section,
    "cv_keys": cvPointKeys,
    "columns": [{
      "grid_size": 12,
      "config": {
        "border-bottom": "1px solid #fff"
      },
      "items": [],
      "rows": [{
        "config": {
        },
        "id": id,
        "target": section,
        "columns": [
          {
            "grid_size": 2,
            "config": {
              "background": "#D9D9D9",
              "text-align": "center",
              "display": "flex",
              "align-items": "center",
              "justify-content": "center",
              "font-weight": "bold"
            },
            "items": [
              {
                "data": `${section}.${i}.activity_name`
              }
            ]
          },
          {
            "grid_size": 10,
            "rows": [...cvDetail],
            "items": []
          }
        ]
      }]
    }]

  })
}
export const reRenderCVPoints = (cvPoints, config) => {
  let academicCVPoints = filterCVPoints(cvPoints, "ACADEMIC"),
    proExpCVPoints = filterCVPoints(cvPoints, "PROFESSIONAL"),
    projectCVPoints = filterCVPoints(cvPoints, "PROJECT")
  let allAcademicPoints = Object.keys(academicCVPoints).reduce((prev, current) => {
    let temp = prev.concat(academicCVPoints[current])
    return temp
  }, [])
  let academicCVHeaders = groupCVHeaders(allAcademicPoints)
  config.section_config.academic_details.section_layout.components.rows[2].columns[0].rows = cvPointDetails(academicCVHeaders);
  let proExpRows = config.section_config.professional_experience.section_layout.components.rows[1].columns[0].rows;
  config.section_config.professional_experience.section_layout.components.rows[1].columns[0].rows = updateRows(proExpRows, proExpCVPoints)
  let projectRows = config.section_config.projects.section_layout.components.rows[1].columns[0].rows
  config.section_config.projects.section_layout.components.rows[1].columns[0].rows = updateRows(projectRows, projectCVPoints)
  let internshipRows = config.section_config.professional_details_internship.section_layout.components.rows[1].columns[0].rows
  config.section_config.professional_details_internship.section_layout.components.rows[1].columns[0].rows = updateRows(internshipRows, proExpCVPoints)
  return config;
}

const updateRows = (rows, cvPoints) => {
  if (Array.isArray(rows)) {
    rows.forEach(row => {
      let headers = groupCVHeaders(cvPoints[row.key] || [])
      row.columns[0].rows = [row.columns[0].rows[0]]
      row.columns[0].rows = row.columns[0].rows.concat(cvPointDetails(headers))
    })
  }
  return rows
}